import { actionTypes } from './actions';

export const reducer = (action) => ({
  [actionTypes.AUTH_START]: () => ({
    isLoginLoading: true,
    isUserLogged: undefined,
    userToken: '',
  }),
  [actionTypes.AUTH_END]: () => ({
    isLoginLoading: false,
    isUserLogged: action.payload.isUserLogged,
    userToken: action.payload.userToken,
  }),
  [actionTypes.REFRESH_START]: () => ({
    isRefreshing: true,
  }),
  [actionTypes.REFRESH_SUCCESS]: () => ({
    refreshError: null,
    isRefreshing: false,
    userToken: action.payload.userToken,
  }),
  [actionTypes.REFRESH_FAILURE]: () => ({
    refreshError: action.payload.error,
    isRefreshing: false,
  }),
});
